var $380965af00afcf9b$exports = {};
$380965af00afcf9b$exports = {
    "replaceMessage": `Largar ficheiro para substituir`
};


export {$380965af00afcf9b$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
